import { storeToRefs } from 'pinia';
import {
  useSessionsStore as usePiniaSessionsStore,
  useSessionsSetters,
} from './use-sessions-store';
import { useSessionsGetters } from './use-sessions-getters';
import { useSessionsGetActions } from './use-sessions-get-actions';
import { useSessionsActions } from './use-sessions-actions';
export { useSessionsSetters, useSessionsGetters };

export const useSessionsStore = () => {
  return {
    ...storeToRefs(usePiniaSessionsStore()),
    ...useSessionsSetters(),
  };
};

export const useSessions = () => {
  return {
    ...useSessionsStore(),
    ...useSessionsGetters(),
    ...useSessionsGetActions(),
    ...useSessionsActions(),
  };
};
